import { render, staticRenderFns } from "./potential-inbound.vue?vue&type=template&id=225b0872&scoped=true&"
import script from "./potential-inbound.vue?vue&type=script&lang=js&"
export * from "./potential-inbound.vue?vue&type=script&lang=js&"
import style0 from "./potential-inbound.vue?vue&type=style&index=0&id=225b0872&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225b0872",
  null
  
)

export default component.exports